import React from 'react'
import { FaBars } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import FotoPerfilMenu from '../FotoPerfilMenu/FotoPerfilMenu'
export default function Navegacion({ onToggle }) {
  return (
    <nav className='navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow'>
      <button
        onClick={onToggle}
        id='sidebarToggleTop'
        className='btn btn-link d-md-none rounded-circle mr-3'
      >
        <FaBars />
      </button>

      <ul className='navbar-nav ml-auto'>
        <li className='nav-item dropdown no-arrow d-sm-none'>
          <Link
            className='nav-link dropdown-toggle'
            to='#'
            id='searchDropdown'
            role='button'
            data-toggle='dropdown'
            aria-haspopup='true'
            aria-expanded='false'
          >
            <i className='fas fa-search fa-fw'></i>
          </Link>
        </li>

        <div className='topbar-divider d-none d-sm-block'></div>

        <FotoPerfilMenu />
      </ul>
    </nav>
  )
}
